import React from "react";
import SortButton from "../../Component/SortButton/SortButton";
import "../CoinsAllotments/CoinAllotmentList.css";

const CoinAllotmentListHeader = ({
  columnSearch,
  setColumnSearch,
  currentSortColumn,
  currentSortOrder,
  onSortChange,
}) => {
  const renderInputColumn = (label, column) => (
    <div className="coinallot-table-cell">
      <p>
        {label}{" "}
        <SortButton
          column={column}
          currentSortColumn={currentSortColumn}
          currentSortOrder={currentSortOrder}
          onSortChange={onSortChange}
        />
      </p>
      <input
        type="text"
        placeholder="Search"
        value={columnSearch[column] || ""}
        onChange={(e) =>
          setColumnSearch({
            ...columnSearch,
            [column]: e.target.value,
          })
        }
      />

    </div>
  );

  const renderDateColumn = (label, column) => (
  <div className="coinallot-table-cell">
    <p>
      {label}{" "}
      <SortButton
        column={column}
        currentSortColumn={currentSortColumn}
        currentSortOrder={currentSortOrder}
        onSortChange={onSortChange}
      />
    </p>

    {/* empty space for alignment */}
    <div style={{ height: "32px" }}></div>
  </div>
);

  return (
    <div className="coinallot-table-row coinallot-table-header">
      <div className="coinallot-table-cell">Sr No</div>
      <div className="coinallot-table-cell">Action</div>

      {renderInputColumn("Trans No", "transactionNo")}
      {renderDateColumn("Trans Date", "datetime")}
      {renderDateColumn("Last Updated", "lastUpdated")}
      {renderInputColumn("Bill Info", "billInfo")}
      {renderInputColumn("Customer", "customer")}
      {renderInputColumn("Coins", "coins")}
      {renderInputColumn("Transaction Remarks", "transactionremarks")}
      {renderInputColumn("User", "user")}

      <div className="coinallot-table-cell">
        <p>
          Status{" "}
          <SortButton
            column="status"
            currentSortColumn={currentSortColumn}
            currentSortOrder={currentSortOrder}
            onSortChange={onSortChange}
          />
        </p>
        <select
          value={columnSearch.status}
          onChange={(e) => setColumnSearch({ ...columnSearch, status: e.target.value })}
        >
          <option value="active">Active</option>
          <option value="deactive">DeActive</option>
        </select>
      </div>
    </div>
  );
};

export default CoinAllotmentListHeader;
